import api from "./api";

export const PREF_PROCESS_COLUMNS = "process_columns";
export const PREF_PROCESS_FILTERS = "process_filters";

export interface UserPreferenceViewModel {
  key: string;
  value: string;
}

export const getUserPreferences = async (): Promise<UserPreferenceViewModel[]> => {
  const response = await api.get(`/api/UserPreference`);
  return response.data;
};

export const saveUserPreference = async (key: string, value: unknown) => {
  const response = await api.put(`/api/UserPreference/${key}`, {
    value: JSON.stringify(value),
  });
  return response.data;
};
